export enum AllowableLoadsTabsEnum {
  LANES = 'Lanes',
  LOADS = 'Loads',
  CHANGES = 'changes',
}
